import request from '@/config/axios'

export interface DistTrackConfigVO {
  id?: number
  track?: string
  enabled?: boolean
  maxLevel?: number
  bindMode?: number
  l1Rate?: number
  l2Rate?: number
  /** @deprecated 已下线三级，保存时固定为 0 */
  l3Rate?: number
  maxTotalRate?: number
  frozenDays?: number
  withdrawMin?: number
  /** 成为分销商资格费（分） */
  joinFee?: number
  /** 无上级时小程序「成为分销商」页展示的平台头像 */
  platformAvatar?: string
  basisWhitelist?: string
}

export const getDistTrackConfig = (track = 'MEMBER') =>
  request.get<DistTrackConfigVO>({ url: '/bosscircle/dist-track-config/get', params: { track } })

export const updateDistTrackConfig = (data: DistTrackConfigVO, track = 'MEMBER') =>
  request.put({ url: '/bosscircle/dist-track-config/update', params: { track }, data })
